import { List as MuiList, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  list: {
    padding: 0
  }
}));

export default function List({ children }) {
  const classes = useStyles();

  return <MuiList className={classes.list}>{children}</MuiList>;
}
